<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 19.773 19.774">
  <g id="Group_25490" data-name="Group 25490" transform="translate(9206.501 6993.759)">
    <g id="Group_25489" data-name="Group 25489" transform="translate(-4648.955 -5539.759)">
      <path id="Icon_awesome-map-marker-alt" data-name="Icon awesome-map-marker-alt" d="M3.449,10.045C.54,5.827,0,5.394,0,3.844a3.844,3.844,0,0,1,7.689,0c0,1.55-.54,1.983-3.449,6.2a.481.481,0,0,1-.79,0Zm.4-4.6a1.6,1.6,0,1,0-1.6-1.6A1.6,1.6,0,0,0,3.844,5.446Z" transform="translate(-4551.503 -1449.239)" />
      <g id="Icon_feather-info" data-name="Icon feather-info" transform="translate(-4556.546 -1453)">
        <path id="Path_18124" data-name="Path 18124" d="M20.774,11.887A8.887,8.887,0,1,1,11.887,3,8.887,8.887,0,0,1,20.774,11.887Z" transform="translate(-3 -3)" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
      </g>
    </g>
  </g>
</svg>

</template>
<script>
export default {
  name: "mapIcon",
};
</script>

<style lang="scss">
#Icon_awesome-map-marker-alt {
  fill: var(--result_map_info_svg_color,#236ca3);
}

#Path_18124 {
  stroke: var(--result_map_info_svg_color,#236ca3);
}

.result__button-secondary {
  #Icon_awesome-map-marker-alt {
    fill: var(--result_button_secondary_font_color,#0a3b74);
  }
  #Path_18124 {
    stroke: var(--result_button_secondary_font_color,#0a3b74);
  }
}


</style>




